module.exports = __webpack_public_path__ + "img/jingdou.21d75daf.png";